// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DropboxSquareFilledSvg from "@fishx/icons-svg/es/asn/DropboxSquareFilled";
import FishxIcon from '../components/FishxIcon';

var DropboxSquareFilled = function DropboxSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DropboxSquareFilledSvg
  }));
};

DropboxSquareFilled.displayName = 'DropboxSquareFilled';
export default React.forwardRef(DropboxSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DropboxSquareFilled.js
// module id = 2488
// module chunks = 0